import { IApplicationState } from '../../types/redux';

export const selectIds = ({ ids }: IApplicationState) => {
  return ids;
};
